import { render, staticRenderFns } from "./_base-select-menu.vue?vue&type=template&id=9374fc7e&scoped=true&"
import script from "./_base-select-menu.vue?vue&type=script&lang=js&"
export * from "./_base-select-menu.vue?vue&type=script&lang=js&"
import style0 from "./_base-select-menu.vue?vue&type=style&index=0&id=9374fc7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9374fc7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItem,VListItemContent,VListItemTitle,VSelect})
